import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAllModulesConfig } from "@/hooks/useAuthConfig";
import { isAdminPreview } from "@/hooks/useModuleVisibility";
import { TrendingUp, Flame, MapPin, ShieldCheck, ArrowRight } from "lucide-react";

const ALL_ITEMS = [
  { label: "Cardiologist",  tag: "Top Search",       to: "/listings?category=2&search=Cardiologist", moduleKey: "doctor" },
  { label: "Dentist",       tag: "Trending",          to: "/listings?category=2&search=Dentist",       moduleKey: "doctor" },
  { label: "Pediatrician",  tag: "Family Care",       to: "/listings?category=2&search=Pediatrician",  moduleKey: "doctor" },
  { label: "Dermatologist", tag: "Skin & Hair",       to: "/listings?category=2&search=Dermatologist", moduleKey: "doctor" },
  { label: "MRI Scan",      tag: "Diagnostics",       to: "/listings?category=6&search=MRI",           moduleKey: "diagnostic" },
  { label: "Blood Test",    tag: "Pathology",         to: "/listings?category=6&search=Blood Test",    moduleKey: "diagnostic" },
  { label: "24x7 Pharmacy", tag: "Always Open",       to: "/listings?category=3&search=24x7",          moduleKey: "medical_store" },
  { label: "Air Ambulance", tag: "Emergency",         to: "/ambulance",                                moduleKey: "ambulance" },
  { label: "Blood A+",      tag: "Live Stock",        to: "/blood-banks",                              moduleKey: "blood_bank" },
  { label: "Eye Hospital",  tag: "Multi-speciality",  to: "/listings?category=1&search=Eye",           moduleKey: "hospital" },
  { label: "IVF Center",    tag: "Fertility",         to: "/listings?category=1&search=IVF",           moduleKey: "hospital" },
  { label: "Physiotherapist", tag: "HomeCare+",       to: "/homecare",                                 moduleKey: "homecare" },
];


const badges = [
  { icon: TrendingUp, label: "Top searched specialties" },
  { icon: Flame, label: "Emergency services" },
  { icon: MapPin, label: "Nearby healthcare" },
  { icon: ShieldCheck, label: "Verified doctors" },
];

const TrendingHealthcare = () => {
  const navigate = useNavigate();
  const moduleConfig = useAllModulesConfig();
  const adminPreview = isAdminPreview();
  const items = ALL_ITEMS.filter(it => {
    if (adminPreview) return true;
    const status = moduleConfig?.[it.moduleKey]?.visibility_status ?? 'LIVE';
    return status === 'LIVE';
  });
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-pill bg-cta-orange/10 text-cta-orange text-xs font-semibold mb-3">
              <Flame className="w-3.5 h-3.5" /> Trending Now
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2">
              Most searched <span className="text-gradient">healthcare services</span>
            </h2>
            <p className="text-muted-foreground">What India is searching for on PataKare this week.</p>
          </div>
          <div className="hidden md:flex flex-wrap gap-2">
            {badges.map((b) => (
              <span key={b.label} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-pill bg-secondary text-foreground/70 text-xs font-medium">
                <b.icon className="w-3.5 h-3.5 text-primary" />
                {b.label}
              </span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 sm:gap-4">
          {items.map((it, i) => (
            <motion.button
              key={it.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.35, delay: i * 0.03 }}
              whileHover={{ y: -4 }}
              onClick={() => navigate(it.to)}
              className="group relative text-left p-4 rounded-2xl bg-secondary/60 hover:bg-card border border-border/50 hover:border-primary/30 hover:shadow-card transition-all"
            >
              <span className="block text-[10px] font-semibold uppercase tracking-wider text-primary/70 mb-1.5">{it.tag}</span>
              <span className="block text-sm font-semibold text-foreground mb-3 line-clamp-1">{it.label}</span>
              <span className="inline-flex items-center text-xs text-primary font-medium">
                Explore <ArrowRight className="w-3 h-3 ml-1 group-hover:translate-x-1 transition-transform" />
              </span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingHealthcare;
